// ============================================================================
// printForm.ts — ПЕЧАТНЫЕ ФОРМЫ (клиентские SSoT-хелперы, шаг 6 учёта):
// формат рендера по типу макета, подписи форматов, байты/скачивание/
// предпросмотр результата RenderLayout (base64 от сервера).
// ============================================================================

/** Формат рендера печатной формы по типу макета (движок internal/layout). */
export const PRINT_FORMAT_BY_TYPE: Record<string, string> = {
  tabular: 'pdf',
  word: 'docx',
  html: 'html',
  text: 'txt',
};

/** Человекочитаемая подпись формата (для диалога выбора печатной формы). */
export function printFormatLabel(format: string): string {
  switch (format) {
    case 'pdf': return 'PDF';
    case 'xlsx': return 'Excel (xlsx)';
    case 'docx': return 'Word (docx)';
    case 'html': return 'HTML';
    case 'txt': return 'Текст';
    case 'image': return 'Изображение';
    default: return format.toUpperCase();
  }
}

/** Формат печати для макета (tabular → PDF — печатный вид; пусто — по типу). */
export function printFormatFor(layoutType: string): string {
  const f = PRINT_FORMAT_BY_TYPE[layoutType];
  if (!f) {
    throw new Error(`тип макета «${layoutType}» не поддерживает печать`);
  }
  return f;
}

/** base64 → Uint8Array (connect-JSON отдаёт bytes строкой). */
export function base64ToBytes(b64: string): Uint8Array {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

/** base64 → Blob (для предпросмотра/скачивания). */
export function base64ToBlob(b64: string, mime: string): Blob {
  const copy = new Uint8Array(base64ToBytes(b64)); // ArrayBuffer-совместимый буфер
  return new Blob([copy], { type: mime || 'application/octet-stream' });
}

/** Скачивание байтов (браузер/WebView2) с освобождением object URL. */
export function downloadBytes(name: string, mime: string, dataB64: string): void {
  const url = URL.createObjectURL(base64ToBlob(dataB64, mime));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Предпросмотр возможен для PDF/HTML (iframe); остальное — скачивание. */
export function isPreviewableMime(mime: string): boolean {
  return mime === 'application/pdf' || mime === 'text/html';
}
